import { isEmpty } from 'lodash'

import { renderPaymentIconWithLabelByPaymentTypeNumber } from 'utils/Orders/renderPaymentIconWithLabelByPaymentTypeNumber'

import { ReactComponent as IconNoPayment } from 'assets/icons/payment/IconNoPayment.svg'

export const getOrderIconAndLabel = (order) => {
  if (isEmpty(order.paymentInfo)) {
    return { icon: <IconNoPayment />, label: 'No Payment' }
  }

  // when paymentInfo contains more than one payment then it is split paymnt
  const isSplitPayment = order?.paymentInfo?.length > 1

  // check if key shortDescription is not empty
  const isShortDescription = !isEmpty(order?.paymentInfo[0]?.shortDescription)

  // return correct paymentType
  const paymentType = isSplitPayment
    ? 'Split Payment'
    : order?.paymentInfo[0]?.paymentTypeEnum

  // card name can be extracted from freedompayIssuerName or issuerName
  const cardName =
    order?.paymentInfo[0]?.userAttributes?.freedompayIssuerName ||
    order?.paymentInfo[0]?.userAttributes?.issuerName

  // lastFour can be extracted from last4 or accountNumberMasked which contains masked numbers which
  // should be removed
  const lastFour =
    order?.paymentInfo[0]?.userAttributes?.last4 ||
    order?.paymentInfo[0]?.userAttributes?.accountNumberMasked?.replace(
      /X/g,
      ''
    )

  // If shortDescription isEmpty we should return Custom Tender
  const paymentTypeDisplayName = isShortDescription
    ? order?.paymentInfo[0]?.shortDescription
    : 'Custom Tender'

  const { icon, label } = renderPaymentIconWithLabelByPaymentTypeNumber({
    paymentType,
    cardName,
    lastFour,
    paymentTypeDisplayName,
  })

  return { icon, label }
}
